module.exports = __webpack_public_path__ + "static/media/bN.7b95d1a4.svg";